import React, { useState, useEffect, useContext } from "react";
import {
  useMutation,
  useManualQuery,
  ClientContext,
} from "graphql-hooks";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";

import {
  Typography,
  Divider,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import PersistentDataGrid from "../../components/PersistentDataGrid";
import Header from "./Header.js";

import { GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID_CLIENT_ID } from "../../graphQL/term_applicant_qry";

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';

import { project_url } from "../../constants/Data";

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -35px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.2rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    paddingTop: 0,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
}));

const ApplicantSprintList = () => {
  const classes = useStyles();
  const [loadContent, setLoadContent] = useState(false);
  const [loadData, setLoadData] = useState(false);

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

 const [clientTermList, setClientTermList] = useState([]);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });

  
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  const [fetchTermApplicantList] = useManualQuery(GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID_CLIENT_ID, {
    fetchPolicy: "network-only",
  }); 

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  let applicantId = 0;
  if(localStorage.getItem("applicantId"))
    applicantId = localStorage.getItem("applicantId");
    
  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");
  
  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat =
      format !== null
        ? formatter1.formatToParts(dayDate)
        : formatter2.formatToParts(dayDate);
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type === "weekday").value +
        ", " +
        dayFormat.find((a) => a.type === "day").value +
        " " +
        dayFormat.find((a) => a.type === "month").value +
        ", " +
        dayFormat.find((a) => a.type === "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type === "month").value +
        " " +
        dayFormat.find((a) => a.type === "day").value +
        ", " +
        dayFormat.find((a) => a.type === "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD") {
      const newFormat =
        dayFormat.find((a) => a.type === "weekday").value +
        ", " +
        dayFormat.find((a) => a.type === "year").value +
        ", " +
        dayFormat.find((a) => a.type === "month").value +
        " " +
        dayFormat.find((a) => a.type === "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type === "month").value +
        "/" +
        dayFormat.find((a) => a.type === "day").value +
        "/" +
        dayFormat.find((a) => a.type === "year").value;
      return newFormat;
    }
  };

  const getTermsList = async () => {
    const {
      loading: termsListLoading,
      error: termsListError,
      data: termsListData,
    } = await fetchTermApplicantList({
        variables: {
          applicantId: parseInt(applicantId),
          clientId: parseInt(clientId)          
        },
    });
    if (!termsListLoading && termsListData && termsListData.getAllTermApplicantsByApplicantIdClientId) {
      console.log(termsListData.getAllTermApplicantsByApplicantIdClientId);
      setClientTermList(termsListData.getAllTermApplicantsByApplicantIdClientId);
            
       setLoadData(true);
    }
    else 
      setLoadData(false);
    if (
      termsListError &&
      termsListError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin/?next=${pathname}`);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTermsList())();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return rows.row.current ? (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >            
            <StyledTooltip title="Current Sprint">
              <Typography variant="h3" style={{ fontSize: 14, marginTop: 15 }}>
                {rows.row.name}
              </Typography>
            </StyledTooltip>
          </Box>
        ) : (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {rows.row.name} 
          </Box>
        );
      },
    },
    {
      field: "startDate",
      headerName: "Sprint Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "Sprint End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    
    {
      field: "action",
      headerName: "Action",
      minWidth: 250,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var dashboardPath = `${project_url}/applicant/sprints/` + rows.row.termUuid;       
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
          <StyledTooltip title="Sprint Dashboard">
              <DashboardOutlinedIcon
                color= "action"
                style={{
                  paddingRight: 10,
                  paddingTop: 6,
                  cursor: "pointer",
                  fontSize: 24,                  
                }}
                onClick={() => navigate(dashboardPath)}
                
              />
           </StyledTooltip>
          
          </Box>
        );
      },
    },
  ];


  var rows = clientTermList
    .filter(application => application.applicationAccepted === true)
    .map(application => ({
        id : application.termId.termId,
        termUuid : application.termId.termUuid,
        name : application.termId.name,
        startDate : dayFormat(application.termId.startDate),
        endDate : dayFormat(application.termId.endDate), 
        current : application.termId.current,       
  }));

  function DataGridTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Sprints List
        </Typography>        
        <Divider />
      </Box>
    );
  }
  
  if (loadContent && loadData)
      return (
        <div className={classes.root}>
          <Header breadcrumbs={[{ label: "Sprints List", link: null }]} />
          <div className={classes.container}>
            <PersistentDataGrid
              persistenceKey="staff-list"
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              slots={{
                toolbar: DataGridTitle,
              }}
              getRowId={row => row.id}
              autoHeight={true}
              experimentalFeatures={{ newEditingApi: true }}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
                sorting: {
                  sortModel: [{ field: "endDate", sort: "desc" }],
                },
              }}
              pageSizeOptions={[10, 25, 50]}
              getRowClassName={params => (params.row.current ? "current-row" : "")}
            />
            <style>
            {`
              .current-row {
                background-color: rgba(203, 255, 139, 0.33) !important; /* Light green */
              }
            `}
          </style>
          </div>
        </div>
      );

  
}
export default ApplicantSprintList;
